import { useState } from 'react';
import LandingPage from './pages/LandingPage';
import PropertyListings from './pages/PropertyListings';
import PropertyDetail from './pages/PropertyDetail';
import RentalDetail from './pages/RentalDetail';
import ProjectDetail from './pages/ProjectDetail';
import AgentProfile from './pages/AgentProfile';
import AgencyProfile from './pages/AgencyProfile';
import BlogsListing from './pages/BlogsListing';
import BlogDetail from './pages/BlogDetail';
import SellProperty from './pages/SellProperty';
import FindDreamHome from './pages/FindDreamHome';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Rent from './pages/Rent';
import Projects from './pages/Projects';
import Agents from './pages/Agents';
import Contact from './pages/Contact';
import ScrollButton from './components/ScrollButton/ScrollButton';

function App() {
  const [currentPage, setCurrentPage] = useState('landing');

  window.navigateTo = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  return (
    <div className="App">
      {currentPage === 'landing' && <LandingPage />}
      {currentPage === 'listings' && <PropertyListings />}
      {currentPage === 'detail' && <PropertyDetail />}
      {currentPage === 'rental-detail' && <RentalDetail />}
      {currentPage === 'project-detail' && <ProjectDetail />}
      {currentPage === 'agent-profile' && <AgentProfile />}
      {currentPage === 'agency-profile' && <AgencyProfile />}
      {currentPage === 'blogs' && <BlogsListing />}
      {currentPage === 'blog-detail' && <BlogDetail />}
      {currentPage === 'sell-property' && <SellProperty />}
      {currentPage === 'find-dream-home' && <FindDreamHome />}
      {currentPage === 'login' && <Login />}
      {currentPage === 'signup' && <Signup />}
      {currentPage === 'forgot-password' && <ForgotPassword />}
      {currentPage === 'rent' && <Rent />}
      {currentPage === 'projects' && <Projects />}
      {currentPage === 'agents' && <Agents />}
      {currentPage === 'contact' && <Contact />}
      <ScrollButton />
    </div>
  );
}

export default App;